
<!-- left-hand side list of folders -->

<!-- <div class="fdm-tree tree_view">
  <div class="tree-node-container text-left">
    <div class="tree-node-home tree-node fdm-link">
      <div class="fdm-link float-left">
        <fa-icon class="fdm-tree-folder" icon="share-alt"></fa-icon>
        Shared links (0)
      </div>
    </div>
  </div>
</div> -->

<mat-tree *ngIf="treeControl" [dataSource]="dataSource" [treeControl]="treeControl" class="fdm-tree tree_view">

  <!-- not sure when this kicks in? -->
  <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding>
    <button mat-icon-button disabled></button>
    {{node.item.name}}
  </mat-tree-node>

  <!-- all folders -->
  <mat-tree-node *matTreeNodeDef="let node; when: hasChild" matTreeNodePadding matTreeNodePaddingIndent="10px">

    <div class="tree-node-container text-left" ngClass="{'selFolder':selectedFolder == node.item}">

      <!-- root folders -->
      <div class="tree-node-home tree-node fdm-link" *ngIf="node.item.root">
        
        <button mat-icon-button class="float-right" color="primary" *ngIf="selectedFolder == node.item && moreMenu" [matMenuTriggerFor]="moreMenu">
          <fa-icon icon="ellipsis-v"></fa-icon>
        </button>
        <button mat-icon-button class="float-right" color="warn" *ngIf="selectedFolder == node.item && showDelete" (click)="folderDelete.emit(node.item)">
          <fa-icon icon="trash"></fa-icon>
        </button>

        <div class="fdm-link float-left" [ngClass]="{'primary':selectedRoot == node.item}"
          [attr.aria-label]="'toggle ' + node.filename" matTreeNodeToggle  (click)="selectFolder(node.item,node)">
          <!-- <fa-icon class="fdm-tree-chevron" [class.fdm-text-invisible]="!node.item.folder_count || node.item.folder_count < 1" [icon]="!treeControl.isExpanded(node)?'chevron-right':'chevron-down'"></fa-icon> -->
          <fa-icon class="fdm-tree-folder" [icon]="[selectedRoot == node.item && node.item.icon !== 'google-drive' && node.item.icon !== 'dropbox' ? 'far' : (node.item.icon !== 'google-drive' && node.item.icon !== 'dropbox') ? 'fas' : 'fab', node.item.icon ]"></fa-icon>
          {{ 'FILE_LIST.ROOT_' + node.item.root | translate:fourD.activeTeam }}
          <mat-progress-spinner diameter="16" *ngIf="node.isLoading" style="display:inline-block" mode="indeterminate"></mat-progress-spinner>
        </div>
        
      </div>

      <!-- all folders under roots -->
      <div class="tree-node" [class.tree-node-selected]="selectedFolder == node.item" *ngIf="!node.item.root && node.item.name !== 'DROPBOX' && node.item.name !== 'GOOGLE DRIVE'">
        
        <button mat-icon-button class="float-right" color="primary" *ngIf="selectedFolder == node.item && moreMenu" [matMenuTriggerFor]="moreMenu">
          <fa-icon icon="ellipsis-v"></fa-icon>
        </button>
        <button mat-icon-button class="float-right" color="warn" *ngIf="selectedFolder == node.item && showDelete" (click)="folderDelete.emit(node.item)">
          <fa-icon icon="trash"></fa-icon>
        </button>

        <div class="fdm-link float-left" [ngClass]="{'primary':selectedFolder == node.item}" [matTooltip]="getType(node)"
          [attr.aria-label]="'toggle ' + node.filename" matTreeNodeToggle (click)="selectFolder(node.item,node)">

          <fa-icon class="fdm-tree-chevron" [icon]="!treeControl.isExpanded(node)?'chevron-right':'chevron-down'" 
            [class.fdm-annotation-color-dark-grey]="treeControl.isExpanded(node)"
            [class.fdm-text-invisible]="!node.item.folder_count || node.item.folder_count < 1"></fa-icon>
          <fa-icon class="fdm-tree-cfolder" [icon]="getIcon(node)"></fa-icon>

          <span>
            {{node.item.name}} <span style="opacity:0.6;font-size:10px;margin-left:4px;">{{ getCount(node) }}</span>
            <mat-progress-spinner diameter="12" *ngIf="node.isLoading" style="display:inline-block;padding-left:10px;" mode="indeterminate"></mat-progress-spinner>
        </span>

          <div class="clearfix"></div>
        </div>

        <!-- <textarea style="width:90%;height:270px;font-size:10px;">{{ node.item | json }}</textarea> -->

      </div>

    </div>

  </mat-tree-node>
</mat-tree>

